import React from 'react';

class OperatorsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelection = this.handleSelection.bind(this);
  }

  handleSelection(e) {
    //sends operator
    this.props.setInputType(e.target.value);
  }

  // whenever new key adding inside the operatorKey in backend
  // keep in mind to add i18n translation value respctive to new keys
  operatorKeyLabel(operatorKey) {
    const operatorLabels = {
      after: t('smart_groups.operator_rule_type.after'),
      before: t('smart_groups.operator_rule_type.before'),
      between: t('smart_groups.operator_rule_type.between'),
      contains: t('smart_groups.operator_rule_type.contains'),
      doesNotContain: t('smart_groups.operator_rule_type.doesNotContain'),
      equalTo: t('smart_groups.operator_rule_type.equalTo'),
      in: t('smart_groups.operator_rule_type.in'),
      isEmpty: t('smart_groups.operator_rule_type.isEmpty'),
      isNotEmpty: t('smart_groups.operator_rule_type.isNotEmpty'),
      notEqualTo: t('smart_groups.operator_rule_type.notEqualTo'),
      notIn: t('smart_groups.operator_rule_type.notIn'),
      notWithinLast: t('smart_groups.operator_rule_type.notWithinLast'),
      on: t('smart_groups.operator_rule_type.operatorOn'),
      withinLast: t('smart_groups.operator_rule_type.withinLast'),
      withinNext: t('smart_groups.operator_rule_type.withinNext'),
    };
    return operatorLabels[operatorKey] || '';
  }

  render() {
    const { operator, data } = this.props;
    return (
      <select
        className="Rule-select"
        value={operator !== null ? operator : ''}
        onChange={this.handleSelection}
        aria-label={t('smart_groups.create_modal.select_operator')}
      >
        <option disabled value="">
          {t('smart_groups.create_modal.select_operator')}
        </option>
        {Object.keys(data).map(operatorKey => (
          <option key={operatorKey} value={operatorKey}>
            {this.operatorKeyLabel(operatorKey)}
          </option>
        ))}
      </select>
    );
  }
}

export default OperatorsDropdown;
